import { RefreshCw, Newspaper } from "lucide-react";
import { Button } from "./ui/button";

interface BottomMenuProps {
  onRefresh: () => void;
  onNewsClick: () => void;
}

export const BottomMenu = ({ onRefresh, onNewsClick }: BottomMenuProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-around items-center">
      <Button
        variant="ghost"
        className="flex flex-col items-center gap-1"
        onClick={onRefresh}
      >
        <RefreshCw className="h-5 w-5" />
        <span className="text-xs">Refresh</span>
      </Button>
      
      <Button
        variant="ghost"
        className="flex flex-col items-center gap-1"
        onClick={onNewsClick}
      >
        <Newspaper className="h-5 w-5" />
        <span className="text-xs">News</span>
      </Button>
    </div>
  );
};